import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=75657196&scoped=true"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"
import style0 from "./Empty.vue?vue&type=style&index=0&id=75657196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75657196",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/home/runner/work/platform/platform/packages/client/src/components/elements/typography/heading/Heading.vue').default})
